import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const Container = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
`

export const LeftContainer = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  width: ${({ isOpen }) => (isOpen ? 240 : 0)}px;

  box-sizing: border-box;
  border-right: 1px solid var(--border-neutral-faded, #dfe2ea);

  display: flex;
  flex-direction: column;

  transition: ${({ isOpen }) =>
    isOpen ? 'width 0.4s cubic-bezier(0.7, 0.01, 0.23, 1.01) 0s' : 'width 0.3s cubic-bezier(0.7, 0.01, 0.23, 1.01) 0s'};
`

export const HeaderLeftContainer = styled.div`
  height: 52px;
  box-sizing: border-box;
  border-bottom: 1px solid white;

  padding: 16px 12px 16px 16px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  :hover {
    .collapse-button {
      opacity: 1;
    }
  }
`

export const FooterLeftContainer = styled.div`
  width: 240px;
  height: 52px;
  box-sizing: border-box;
  border-bottom: 1px solid white;

  padding: 16px 12px 16px 16px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const RightContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
`

export const HeaderRightContainer = styled.div`
  height: 52px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-neutral-faded, #dfe2ea);

  gap: 12px;
  padding: 16px;

  display: flex;
  flex-direction: row;
  align-items: center;

  position: relative;
`

export const SideBarContainer = styled.div`
  width: 240px;

  flex: 1;

  z-index: 8;

  background-color: white;
  display: flex;
`

export const MainContainer = styled.div`
  flex: 1;

  display: flex;
`

export const CollapseButtonContainer = styled.div`
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  box-sizing: border-box;

  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  border-radius: 4px;
  background: var(--background-neutral-faded, #f3f4f6);

  opacity: 0;

  transition: opacity 0.3s;

  svg {
    font-size: 16px;
    color: var(--foreground-neutral-faded, #4d5874);
  }
`

export const ImgLogo = styled.img`
  width: 72px;
  min-height: 20px;
`

export const ExpandButtonContainer = styled.div<{ isOpen: boolean }>`
  cursor: ${({ isOpen }) => (isOpen ? 'default' : 'pointer')};

  display: flex;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-base, #fff);

  opacity: ${({ isOpen }) => (isOpen ? 0.1 : 1)};
  width: ${({ isOpen }) => (isOpen ? 0 : 26)}px;
  padding: ${({ isOpen }) => (isOpen ? 0 : 4)}px;

  overflow: hidden;

  transition: ${({ isOpen }) =>
    isOpen
      ? 'width 0.4s cubic-bezier(0.7, 0.01, 0.23, 1.01) 0s, opacity 0.4s, padding 0.4s'
      : 'width 0.3s cubic-bezier(0.7, 0.01, 0.23, 1.01) 0s, opacity 0.3s, padding 0.4s'};

  svg {
    font-size: 16px;
    color: var(--foreground-neutral, #14171f);
  }
`

export const ProjectRowContainer = styled.h1`
  text-decoration: none;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid var(--border-neutral-faded, #fff);
  background: var(--background-elevation-base, #fff);
`

export const ProjectRowIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;
`

export const ProjectRowIcon = styled.img``

export const ProjectRowLabel = styled.div`
  color: var(--foreground-neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  max-width: 130px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AdminButtonContainer = styled(NavLink)`
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 22px;
    color: var(--foreground-neutral, #14171f);
  }
`

export const HeaderComponentContainer = styled.div`
  position: absolute;

  top: 0px;
  left: 252px;

  height: 100%;

  padding: 0 24px;
  box-sizing: border-box;
`

export const PlanningFadeContainer = styled.div<{ isAdminPath?: boolean }>`
  margin: auto;

  color: var(--Foreground-Neutral, #14171f);
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  pointer-events: none;

  transition: opacity ${({ isAdminPath }) => (isAdminPath ? 0 : 0.4)}s cubic-bezier(0.7, 0.01, 0.23, 1.01) 0s;
`

export const AdminButtonEditPlanning = styled(NavLink)`
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 120px;
  max-height: 200px;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 4px;

  padding: 4px;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-overlay, #fff);
`
